/*
 * Saidai — 多段（ステップ）お問い合わせフォーム
 *
 * 1画面ずつ入力 → 丸いステップ表示 → 次へ／戻る、というUXを、
 * 非公開Shopify保存フォームに載せるステップ操作の層。
 *
 * JSが動かない場合は全ステップが縦に並んだ通常のフォームとして機能する
 * （is-active を付けない限り display:none にはしない。CSSは .sd-stepform.is-js
 *  が付いたときだけステップ表示に切り替わる）。
 */
(function () {
  'use strict';

  function setup(root) {
    var form = root.querySelector('form');
    if (!form) return;

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-sd-step]'));
    if (steps.length < 2) return;

    var markers = Array.prototype.slice.call(root.querySelectorAll('[data-sd-progress-step]'));
    var nextButton = root.querySelector('[data-sd-next]');
    var prevButton = root.querySelector('[data-sd-prev]');
    var submitButton = root.querySelector('.sd-stepform__submit');
    var current = 0;

    /* JSが動いた時点でステップ表示に切り替える */
    root.classList.add('is-js');

    function show(index, moveFocus) {
      current = Math.max(0, Math.min(steps.length - 1, index));
      steps.forEach(function (s, i) {
        s.classList.toggle('is-active', i === current);
      });
      markers.forEach(function (marker, i) {
        marker.classList.toggle('is-active', i === current);
        marker.classList.toggle('is-complete', i < current);
      });
      if (prevButton) prevButton.hidden = current === 0;
      if (nextButton) nextButton.hidden = current === steps.length - 1;
      if (submitButton) submitButton.hidden = current !== steps.length - 1;
      /* 進んだ先の最初の入力へフォーカスを移す */
      if (moveFocus !== false) {
        var first = steps[current].querySelector('input, select, textarea');
        if (first) first.focus({ preventScroll: true });
      }
    }

    /* そのステップ内の必須項目だけを検証する */
    function clearFieldError(field) {
      field.classList.remove('is-invalid');
      field.removeAttribute('aria-invalid');
      var error = field.parentNode.querySelector('.sd-stepform__field-error');
      if (error) error.remove();
    }

    function showFieldError(field) {
      clearFieldError(field);
      field.classList.add('is-invalid');
      field.setAttribute('aria-invalid', 'true');
      var error = document.createElement('span');
      error.className = 'sd-stepform__field-error';
      error.textContent = field.validity.valueMissing
        ? 'この必須項目を入力してください。'
        : '入力内容をご確認ください。';
      field.insertAdjacentElement('afterend', error);
    }

    function validate(step) {
      var fields = Array.prototype.slice.call(
        step.querySelectorAll('input, select, textarea')
      );
      var ok = true;
      fields.forEach(function (f) {
        clearFieldError(f);
        if (!f.checkValidity()) {
          ok = false;
          showFieldError(f);
          f.focus({ preventScroll: true });
          throw new Error('stop');
        }
      });
      return ok;
    }

    root.addEventListener('click', function (e) {
      var next = e.target.closest('[data-sd-next]');
      var prev = e.target.closest('[data-sd-prev]');
      if (!next && !prev) return;
      e.preventDefault();
      if (next) {
        try {
          validate(steps[current]);
        } catch (err) {
          return; /* 未入力があればそのステップに留まる */
        }
        show(current + 1);
      } else {
        show(current - 1);
      }
    });

    form.addEventListener('input', function (e) {
      if (e.target.matches('input, select, textarea') && e.target.checkValidity()) {
        clearFieldError(e.target);
      }
    });

    /* Enterで意図せず送信されないよう、最終ステップ以外は次へ扱いにする */
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      if (e.target.tagName === 'TEXTAREA') return;
      if (current < steps.length - 1) {
        e.preventDefault();
        if (nextButton) nextButton.click();
      }
    });

    show(0, false);
  }

  function init() {
    var roots = document.querySelectorAll('[data-sd-stepform]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
